export default {
	resetFilter ({commit}) {
		commit('RESET_FILTER')
	}
}
